import { authHeader, handleResponse, handleError } from '../helper';
import CurriculumApiHelper from "../common/CurriculumApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import axios from 'axios';

export const curriculumDashboardService = {
    getAverageScoresByLevel,
    getUsersByLevel,
    getTopCurriculums,
    getUsersListByLevel,
    getAttendedCurriculumUsers,
    getUsersStatusByCurriculum,
    getUserCurriculumStatus,
    exportUserScores

}
const webAPIURL = () => {
    //const { REACT_APP_PUBLIC_URL } = process.env;
    let url = `${new URL(window.location.origin)}curriculum-api`;
    return url
};
function getAverageScoresByLevel() {
    return CurriculumApiHelper.get(APIURLConstants.GET_CURRICULUM_AVERAGE_TIME_BY_LEVEL, authHeader())
        //.then(handleResponse)
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));
            // currentUserSubject.next(user);
            return data;
        }).catch(handleError);
}

function getUsersByLevel() {
    return CurriculumApiHelper.get(APIURLConstants.GET_USERS_BY_LEVEL, authHeader())
        //.then(handleResponse)
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));
            // currentUserSubject.next(user);
            return data;
        }).catch(handleError);
}

function getTopCurriculums(payload) {
    return CurriculumApiHelper.post(APIURLConstants.GET_TOP_CURRICULUMS, payload, authHeader())
        .then(data => {
            return data;
        }).catch(handleError);
}


function getUsersListByLevel(id) {
    return CurriculumApiHelper.get(APIURLConstants.GET_USERS_LIST_BY_LEVEL(id), authHeader())
        //.then(handleResponse)
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));
            // currentUserSubject.next(user);
            return data;
        }).catch(handleError);
}

function getAttendedCurriculumUsers(id) {
    return CurriculumApiHelper.get(APIURLConstants.GET_ATTENDED_CURRICULUM_USERS(id), authHeader())
        //.then(handleResponse)
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));
            // currentUserSubject.next(user);
            return data;
        }).catch(handleError);
}

function getUsersStatusByCurriculum(id) {
    return CurriculumApiHelper.get(APIURLConstants.GET_USERS_STATUS_BY_CURRICULUM(id), authHeader())
        //.then(handleResponse)
        .then(data => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            // localStorage.setItem('currentUser', JSON.stringify(user));
            // currentUserSubject.next(user);
            return data;
        }).catch(handleError);  
}

function getUserCurriculumStatus(id) {

     let headers = authHeader();
        headers.responseType = 'blob';
        let apiURL = webAPIURL();
    
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                responseType: 'arraybuffer', //Force to receive data in a Blob Format
                url: apiURL + APIURLConstants.DOWNLOAD_USER_CURRICULUM_STATUS(id),
              
                headers: headers
            }).then(response => {
                resolve(response);
            }).catch(err => {
                reject(err)
            })
        })
    
    
}

function exportUserScores(curriculumIds) {
    let headers = authHeader();
    headers.responseType = 'blob';
    let apiURL = webAPIURL();

    return new Promise((resolve, reject) => {
        axios({
            method: 'post',
            responseType: 'arraybuffer',
            url: apiURL + APIURLConstants.EXPORT_USER_SCORES,
            data: { curriculumIds },
            headers: headers
        }).then(response => {
            resolve(response);
        }).catch(err => {
            reject(err)
        })
    })
}

